export const BAC_ABOUT_DATA = {
  about: {
    title: {
      fr: 'Ecole Girard - Section Française Internationale',
      ar: 'مدرسة جيرار - القسم الفرنسي الدولي',
      en: 'Girard School - French International Section',
    },
    content: {
      fr: `La Section Française Internationale (bac ) de l'école Girard, établie en 2019, suit le système d'éducation français. Des professeurs compétents de différentes nationalités y enseignent, offrant une éducation de qualité dans un environnement multiculture.`,
      ar: `تأسس القسم الفرنسي الدولي بمدرسة جيرار عام 2019م. 
يتبع القسم نظام التعليم الفرنسي ويدرس فيه معلمون مؤهلون من جنسيات مختلفة، مما يوفر تعليمًا عالي الجودة في بيئة متعددة الثقافات.
`,
      en: `"The French International Section at Girard school was established in 2019.
The section follows the French education system and is taught by qualified teachers from various nationalities, providing high-quality education in a multicultural environment."
`,
    },
    image: 'GIR SI 2 2025.jpg',
  },
  vision: {
    title: {
      fr: 'Vision',
      ar: 'رؤية المدرسة',
      en: 'Vision',
    },
    content: {
      fr: ` Cet enseignement de qualité vise à former une étudiante plurilingue, créatrice apte à s’adapter aux perpétuels changements, ayant une personnalité distincte, autonome, active et ouverte à l’international.`,
      ar: `تهدف هذه التربية عالية الجودة إلى تكوين طالبة متعددة اللغات، مبدعة وقادرة على التكيف مع التغيرات المستمرة، ذات شخصية متميزة، مستقلة، نشطة ومنفتحة على العالم.`,
      en: `This quality education aims to train a multilingual student, a creative individual capable of adapting to perpetual changes, with a distinctive, independent, active personality, and open to international opportunities.`,
    },
    image: 'GIR SI 1 2025.jpg',
  },
  mission: {
    title: {
      fr: 'Mission',
      ar: 'رسالة المدرسة',
      en: 'Mission',
    },
    content: {
      fr: `* Développer le sens critique, l’esprit de recherche et l’expérimentation.</br>
* L’étudiante est donc au centre de l’apprentissage </br>
* Concevoir un environnement d’apprentissage francophone et international qui cultive la curiosité, la créativité, l’indépendance d’esprit, la collaboration interculturelle et la communication.</br>
* S’appuyer sur les nouvelles technologies pour enrichir l’expérience éducative.</br>
* Doter tous les élèves des compétences nécessaires à leur épanouissement dans un monde où les sciences, l’ingénierie et la technologie jouent un rôle clef.</br>
* Apporter un soutien scolaire personnalisé, ainsi qu’un suivi pédagogique et une aide à l’orientation, adaptés aux besoins et intérêts de chaque élève.</br>
* Stimuler l’épanouissement personnel, le travail en équipe et le leadership des élèves grâce à un éventail élargi d’activités périscolaires.</br>
`,
      ar: `•	تطوير الحس النقدي، وروح البحث والتجربة</br>
•	الطالبة هي في صميم عملية التعلم.</br>
•	تصميم بيئة تعلم فرنكوفونية ودولية تعزز الفضول والإبداع، والاستقلالية الفكرية، والتعاون بين الثقافات، والتواصل.</br>
•	الاعتماد على التقنيات الحديثة لتعزيز العملية التعليمية.</br>
•	تزويد جميع الطلاب بالمهارات اللازمة لتحقيق ازدهارهم في عالم تلعب فيه العلوم والهندسة والتكنولوجيا دوراً مهماً.</br>
•	تقديم الدعم الأكاديمي الشخصي، بالإضافة إلى المتابعة التربوية والمساعدة في التوجيه، بما يتناسب مع احتياجات واهتمامات كل طالب.</br>
•	تحفيز النمو الشخصي والعمل الجماعي والقيادة لدى الطلاب من خلال مجموعة واسعة من الأنشطة اللاصفية.</br>
`,
      en: `•	Develop critical thinking, research spirit, and experimentation.</br>
•	The student is therefore at the center of the learning process.</br>
•	Design a Francophone and international learning environment that fosters curiosity, creativity, independence of mind, intercultural collaboration, and communication.</br>
•	Leverage new technologies to enrich the educational experience.</br>
•	Equip all students with the skills necessary for their flourishing in a world where science, engineering, and technology play a key role.</br>
•	Provide personalized academic support, along with educational monitoring and guidance, tailored to each student's needs and interests.</br>
•	Stimulate personal development, teamwork, and leadership among students through a wide range of extracurricular activities.</br>
`,
    },
    image: 'Mission.jpg',
  },
  contact: {
    address: {
      fr: '8 Rue Gaber El Ghazaly, Stanely',
      ar: '8 ش جابر الغزالى‎ ستانلى،',
    },
    phone: '+203 5420137 / +203 5420137',
    mail: 'info@ecole-girard.net',
    facebook:
      'https://www.facebook.com/p/Ecole-Girard-Section-Fran%C3%A7aise-Internationale-BAC-100065469009847/',
    twitter: 'https://x.com/EcoleGirard',
    youtube: 'https://www.youtube.com/user/EcoleGirard',
    instagram: 'https://www.instagram.com/girar.sec.francaise2022/',
    linkedIn: 'https://www.linkedin.com/',
  },
  history: [
    {
      title: {
        fr: 'Historique',
        ar: 'تاريخ المدرسة',
      },
      description: {
        fr: `Fondé par Aimé-Antonin Girard il y a plus d’un siècle, l’établissement est une des plus anciennes écoles de langue. Elle est considérée comme le phare de la culture, de la science et de l’éducation à Alexandrie.`,
        ar: `تعد مدرسة جيرار منارة للثقافة والعلم والتربية وتمثل واحدة من أعرق مدارس اللغات فى الإسكندرية حيث تضرب بجذورها فى أراضى الاسكندرية منذ ما يزيد عن قرن من الزمان حيث استقر الأستاذ/جيرار بالإسكندرية فى القرن التاسع عشر وتحديداً فى عام الف وثمانية وتسعين للميلاد وأسس معهد جيرار الفرنسى ببوكلى`,
      },
      imageUrl: null,
      videoUrl: null,
    },
    {
      title: {
        fr: 'Qui est monsieur Aimé-Antonin Girard ?',
        ar: 'الأستاذ جيرار فى سطور',
      },
      description: {
        fr: `Officier de l’institution publique (janvier 1905)
Chevalier de l’Ordre Impérial de l’Osmanlie
Ancien chef d’Institution, Lauréat du conservatoire de musique
Ex-directeur des études françaises au collège grec-catholique à Beyrouth et en Syrie
Ex-directeur des études françaises à l’Université Américaine à Beyrouth et en Syrie
Ex-secrétaire chancelier du Consulat Général des Pays-Bas à Beyrouth et en Syrie
Ex-gérant du Consulat Général de Roumanie en Syrie et en Palestine
Ex-chirurgien aide-major à l’armée de la Loire durant la guerre de 1870-1871
Enseignant de langues vivantes, de mathématiques, de comptabilité
Enseignant du latin par une méthode simple
Enseignant de cours simultané d’histoire, de géographie, littérature et mythologie`,
        ar: `استقر بعد رحلة طويلة بالإسكندرية 1890كان يشغل منصب موظف بالتعليم العام يناير 1905حصل على درجة فارس من الأمبرطورية العثمانيةأحد الرواد المؤسسين لمعهد الموسيقىالمدير السابق للدراسات الفرنسية بالجامعة الأمريكية بيروت وسورياسكرتير الرئيس السابق للقنصلية الهولندية ببيروتالمفوض السابق للقنصلية الرومانية العامة فى فلسطين وسو ريامساعد جراح فى الجيش العثمانى فى حرب اللوار 1870ـ1871أستاذ اللغات الحية والرياضيات والمحاسبةمدرس اللغة اللاتينية بطريقة بسيطة وسهلة وسريعةحصص متزامنة فى التاريخ والجغرافيا والأدب والمثيولوجيا أي علم الأساطيرحصل على شهادة تركيا من الدرجة الأولى`,
      },
      imageUrl: null,
      videoUrl: 'NBq0KX4zfKo',
    },
    {
      title: {
        fr: 'Histoire et objectifs de l’établissement',
        ar: 'أهداف المؤسس',
      },
      description: {
        fr: `En 1890, Aimé-Antonin Girard vint s’installer à Alexandrie et ouvrit à Bulkley l’institution française Girard. D’année en année l’école progressa sous sa direction avec l’aide de sa femme madame Girard.`,
        ar: `كان الأستاذ إيميه انتونين جيرار يهدف من إنشاء المعهد إلى بناء الإنسان علمياً ووجدانياً وانسانيا ثم تولت أخته تيريز جيرار إدارة المدرسة بعد وفاته وساعدتها فى الإدارة أختها الثانية مارى لويز دوفونسيكا، وعندما بلغت الأختان السبعين من عمريهما بحثتا عمن يدير المدرسة واستقر بهما الأمر إلى الإتفاق مع الراهبات على إدارة المدرسة 1951 حيث تم توقيع العقود رسميا فى يوليو 1951`,
      },
      imageUrl: null,
      videoUrl: null,
    },
    {
      title: {
        fr: 'Les objectifs de l’institution étaient :',
        ar: 'ومن أبرز الأحداث التاريخية للمدرسة',
      },
      description: {
        fr: `Former les intelligences
diriger vers le bien les cœurs et les esprits.
A la mort de monsieur Girard, sa fille mademoiselle Thérèse Girard prit la direction. Plus tard, sa sœur madame Marie-Louise de Fonseca l’aida dans la direction. Dès 1949, toutes deux très âgées (70 ans environ), cherchaient une congrégation pour prendre en charge l’école afin de continuer leur œuvre. En juillet, en 1951, on tombe d’accord pour la passation de l’école aux sœurs franciscaines de Marie.`,
        ar: `زيارة جلالة الملك فؤاد الأول يوم السبت العاشر من نوفمبر 1921.
        زيارة معالى رئيس وزراء مصر الأسبق نجيب الهلالى باشا 1944
زيارة دكتور طه حسين وزير المعارف وعميد جامعة فاروق بصحبة عبد الخالق حسونة باشا محافظ الأسكندرية
منزل الراهبات. لمشاهدة الصور اضغط هناصور الإحتفال بمئوية المدرسة – 29 ابريل 2010
فندق جولي فيل – رامادا سابقاً
لمشاهدة الصور اضغط هنا`,
      },
      imageUrl: null,
      videoUrl: 'wHs0Rt6Ka4U',
    },
    {
      title: {
        fr: 'Parmi les événements historiques les plus importants :',
        ar: '',
      },
      description: {
        fr: `Visite de Sa Majesté le Roi Fouad 1er le samedi 10 novembre 1921. Visite du ministre de l’institution publique Naguib El HELALAI Pacha, du recteur de l’université Farouk 1er Taha HUSSEIN et du gouverneur d’Alexandrie Abdel Khalek HASSOUNA le 22 janvier 1944.
        Maison des soeurs. Pour voir les photos: cliquez ici
Centenaire de l’établissement – 29 avril 2010 – hôtel Jolie Ville (Ramada).
Pour voir les photos: cliquez ici`,
        ar: `منزل الراهبات. لمشاهدة الصور اضغط هناصور الإحتفال بمئوية المدرسة – 29 ابريل 2010
فندق جولي فيل – رامادا سابقاً
لمشاهدة الصور اضغط هنا`,
      },
      imageUrl: null,
      videoUrl: 'M_OpzlYv68M',
    },
  ],
  tour: {
    videoUrl: 'JXLLtCeUObg',
  },
  staff: {
    yearPhoto: 'yearPhoto.jpg',
    staffDetails: [
      { image: 'team-1.jpg', name: 'Name1', job: 'Job1' },
      { image: 'team-2.jpg', name: 'Name2', job: 'Job2' },
      { image: 'team-3.jpg', name: 'Name3', job: 'Job3' },
      { image: 'team-1.jpg', name: 'Name4', job: 'Job4' },
      { image: 'team-2.jpg', name: 'Name5', job: 'Job5' },
      { image: 'team-3.jpg', name: 'Name6', job: 'Job6' },
    ],
  },
};
